<!-- Pug Template -->
<template lang="pug">
ol.list-article-toc
  li(
    v-for="(link, i) in links"
    :class="{active: index === i, [link.class]: true}"
  )
    a(
      @click.prevent="updateHistory(link.permalink, link.title, i)"
      :href="link.permalink"
    ) {{ link.title }}
</template>

<!-- Script -->
<script>
export default {
  props: {
    permalink: String,
    index: Number,
    items: Array,
    title: String
  },

  data(){
    const links = [{
      class: 'introduction',
      permalink: this.permalink,
      title: this.title
    }];
    this.items.forEach( item => {
      item.class = 'item';
      links.push(item);
    });
    return { links };
  },

  mounted(){
    const $ct = document.getElementById('list-article-toc');
    if( $ct ){
      $ct.appendChild(this.$el);
    }
  },

  destroyed(){
    if( this.$el.parentNode ){
      this.$el.parentNode.removeChild( this.$el );
    }
  },

  methods: {
    updateHistory(link, title, i){
      const a = document.createElement('a');
      a.href=link;
      window.history.pushState({index: i},title,a.pathname);
      this.$emit('index', i);
    }
  }
};
</script>

<!-- SCSS Style -->
<style lang="scss" scoped>
@import '../../../scss/front/variables'; 
.list-article-toc{
  margin-top: 2.5em;
  counter-reset: items -1;
  li {
    list-style: none;
    counter-increment: items;
    display: block;
    position: relative;
    &.active {
      font-weight: bold;
    }
    &.introduction {
      font-family: $font-serif;
      color: $color-warm-gray-11;
      font-weight: bold;
      font-size: 1.5rem;
      margin-bottom: 0.75em;
      line-height: 1.2;
      a {
        color: inherit;
      }
    }
    &.item{
      font-size: 1rem;
      line-height: 1.5em;
      margin-bottom: 0.6em;
      color: $color-warm-gray-99;
      a {
        padding-left: 2.25em;
        color: inherit;
        &:before {
          top: -0.08em;
          font-size: 0.9em;
          position: absolute;
          left: 0;
          display: flex;
          width: 1.85em;
          height: 1.85em;
          justify-content: center;
          align-items: center;
          background: $color-gray-3;
          color: #fff;
          font-weight: normal;
          border-radius: 50%;
          content: counter(items);
          transition: 0.2s background-color;
        }
      }
      &.active {
        font-weight: bold;
        a:before {
          background-color: $color-dark-green;
        }
      }
    }
  }
}
</style>i